import React, { useEffect, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import NotificationListItemMintCal from "../NotificationListItemMintCal";
import { Collection, UserMetadata } from "../../types";
import Button from "../Button";
import { InputField } from "../InputField";
import { Routes } from "../../constants";
import { useAuth } from "../../contexts/AuthContext";
import { useApi } from "../../contexts/ApiContext";


// const NotificationListMintCal = React.memo((props: any) => {
//   const { push } = useHistory()

//   const { currentUserMetadata } = useAuth()
//   const { retrieveMintCalendar } = useApi()

//   const { mintCalendars } = props


//   const editCollection = (collection: Collection) => {
//     push(`${Routes.MINT_CALENDAR}/${collection.id}`);
//   };
//   // const loadMoreItems = async () => {
//   //   setListLength(current => current + 5);
//   //   if (currentUserMetadata?.role === "admin") {
//   //     const retrieveMoremintCalendars: any = state !== mintCalendarstate.deleted ? await retrievemintCalendarsByType({ offset: offset, limit: 10, state }, mintCalendarstate.live) :
//   //       await retrieveDeletedmintCalendars({ offset: offset, limit: 10 })
//   //     const moremintCalendars = retrieveMoremintCalendars ? retrieveMoremintCalendars : []
//   //     setOffset(current => current + 10)
//   //     setCollecs([...collecs, ...moremintCalendars])
//   //   }

//   // };
//   return (
//     <div className="flex flex-col">
//       {mintCalendars?.length > 0 &&
//         mintCalendars?.map(
//           (mintcal: any, idx: any) => (
//             <NotificationListItemMintCal
//               onClick={(collection: any) => editCollection(collection)}
//               key={mintcal.id}
//               mintcal={mintcal}
//             />
//           )
//         )}
//       {mintCalendars?.length === 0 && (
//         <div>No Mint Calendars at the moment.</div>
//       )}

//     </div>
//   );
// });

const NotificationListMintCal = React.memo(({ mintCalendars, stage, state }: any) => {
  const { push } = useHistory();


  const [searchValue, setSearchValue] = useState<string>("");
  const [listLength, setListLength] = useState(6);
  const [offset, setOffset] = useState(100)
  const [collecs, setCollecs] = useState<any[]>([])
  const { currentUserMetadata, isCurrentUserAdmin } = useAuth()
  const { retrieveMintCalendar } = useApi()
  const isAdmin = isCurrentUserAdmin();

  useEffect(() => {
    if (mintCalendars) {
      setCollecs([...mintCalendars])
    }
  }, [mintCalendars])


  const editCollection = (collection: Collection) => {
    push(`${Routes.MINT_CALENDAR}/${collection.id}`);
  };

  const searchResults = collecs.filter(
    (collection) =>
      collection?.name?.toLowerCase()?.includes(searchValue) && collection
  );

  const dateOrderedArray = collecs


  const loadMoreItems = async () => {
    // let variables: any = isAdmin ? { offset: offset, isOwn:true } : { creator: currentUserMetadata?.userId, offset: offset, isOwn:true }
    // variables = state == "pending" ? { ...variables, isApproved: false, isRejected: false } : state == "approved" ? { ...variables, isApproved: true } : { ...variables, isRejected: true }
    setListLength(current => current + 5);
    // const retrieveMoreMintCalendars: any = await retrieveMintCalendar(variables)
    // const moremintCalendars = retrieveMoreMintCalendars ? retrieveMoreMintCalendars : []
    setOffset(current => current + 10)
    // setCollecs([...collecs, ...moremintCalendars])


  };

  return (
    <div className="flex flex-col">
      {currentUserMetadata?.role === "admin" && dateOrderedArray?.length > 5 && (
        <InputField
          onChange={(e) => setSearchValue(e.target.value)}
          value={searchValue}
          label="Search mint Calendars"
        />
      )}
      <div className="grid sm:grid-cols-1 lg:grid-cols-2 sm:gap-4 lg:gap-8 w-full">
        {dateOrderedArray.length > 0 && searchValue.length === 0
          ? dateOrderedArray.map(
            (mintcal, idx) =>
              idx + 1 <= listLength && (
                <NotificationListItemMintCal
                  onClick={(collection: any) => editCollection(collection)}
                  key={mintcal.id}
                  mintcal={mintcal}
                />
              )
          )
          : searchResults?.map(
            (mintcal, idx) =>
              idx + 1 <= listLength && (
                <NotificationListItemMintCal
                  onClick={(collection: any) => editCollection(collection)}
                  key={mintcal.id}
                  mintcal={mintcal}
                />
              )
          )}
      </div>

      {dateOrderedArray?.length === 0 && (
        <div className="mb-6 mt-2">No Mint Calendars at the moment.</div>
      )}
      {dateOrderedArray?.length >= listLength && (
        <Button
          type="button"
          className="my-4 ml-auto mr-auto btn flex bg-gradient text-kyzzen-primary font-medium"
          onClick={loadMoreItems}
        >
          Show more
        </Button>
      )}
      <hr className="border border-gray-80 "/>
    </div>
  );
});

export default NotificationListMintCal;
